import React, { createContext, useContext, useRef } from "react";

const FeatureFlagsContext = createContext<Record<string, boolean>>({});

const FeatureFlagsProvider = ({
  flags,
  children,
}: {
  flags: Record<string, boolean>;
  children: React.ReactNode;
}) => {
  const ref = useRef(flags);
  return (
    <FeatureFlagsContext.Provider value={ref.current}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

const useFeatureFlags = () => useContext(FeatureFlagsContext);

export { FeatureFlagsContext, FeatureFlagsProvider, useFeatureFlags };
export default FeatureFlagsProvider;
